
// pages/CaseStudies/CaseStudies.jsx - DevLearn-branded responsive grid
import { useState } from 'react';
import { ArrowRight, Calendar, Shield } from 'lucide-react';
import '../../index.css';
import './CaseStudies.css';

const projects = [
  {
    title: 'Development of Comprehensive Safeguarding, Safety, and Well-Being Database',
    client: 'Restless Development Zambia',
    date: 'Oct - Dec 2025',
    description: 'Conducting regional needs assessment, designing a multilingual safeguarding and well-being database, creating youth-friendly training materials on safeguarding, digital safety, and mental health, and facilitating validation and capacity-building sessions with youth CSOs.',
    results: 'Ongoing: Building inclusive tools to protect and empower Zambian youth; expected reach: 500+ CSOs; integrates MERL for real-time monitoring.',
    icon: <Shield size={56} color="#F7941D" />
  },
  // {
  //   title: 'Health Systems Evaluation for HIV/AIDS Interventions',
  //   client: 'CIDRZ & NFNC Partnership',
  //   date: '2024',
  //   description: 'Mixed-methods impact evaluation of RMNCAH and HIV/AIDS programs, using STATA and NVivo for data analysis and stakeholder engagement.',
  //   results: 'Improved program efficacy by 25%; informed policy for 10,000+ beneficiaries; led to scaled clinical trials.',
  //   icon: <TrendingUp size={56} color="#BA477C" />
  // },
  // {
  //   title: 'Governance and Anti-Corruption Policy Analysis',
  //   client: 'UNECA & Oxfam Zambia',
  //   date: '2023',
  //   description: 'Political economy analysis and citizen surveys to evaluate transparency measures, with econometric modeling for policy recommendations.',
  //   results: 'Influenced legislative reforms; 15% increase in public trust metrics; supported multi-stakeholder advocacy.',
  //   icon: <FileText size={56} color="#FBB040" />
  // },
  // {
  //   title: 'Youth Skills and Entrepreneurship Training Framework',
  //   client: 'ChildFund Zambia',
  //   date: '2024',
  //   description: 'Designed digital skills curriculum and employability assessments for underserved youth, incorporating participatory M&E with KoboToolbox.',
  //   results: 'Trained 2,000+ youth; 30% employability boost; adopted as national model for future-of-work programs.',
  //   icon: <Award size={56} color="#F7941D" />
  // },
  // {
  //   title: 'Climate Resilience and Green Livelihoods Assessment',
  //   client: 'Prospero & Local CSOs',
  //   date: '2025 (Ongoing)',
  //   description: 'Community-led evaluation of adaptation practices using satellite data and mixed-methods, focusing on environmental justice in rural Zambia.',
  //   results: 'Enhanced yields for 1,500 farmers; reduced emissions by 20%; guided donor funding for sustainability.',
  //   icon: <TrendingUp size={56} color="#BA477C" />
  // }
];

const CaseStudies = () => {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <>
      {/* Hero */}
      <section className="hero" style={{ background: 'linear-gradient(180deg, #F7941D33 0%, #ffffff 100%)' }}>
        <div className="container">
          <h1 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '700' }}>Our Projects</h1>
          <p style={{ fontFamily: 'Poppins, sans-serif', color: '#1F2937' }}>
            Real-world applications of our MERL expertise. From youth safeguarding to governance reforms, explore how DevLearn delivers measurable, evidence-led impact in Zambia and across Africa.
          </p>
          <div className="hero-buttons">
            <a href="#projects" className="btn btn-primary" style={{ background: '#F7941D', color: '#fff', fontFamily: 'Poppins, sans-serif' }}>
              Explore Projects <ArrowRight />
            </a>
            <a href="/services" className="btn btn-secondary" style={{ borderColor: '#FBB040', color: '#FBB040', fontFamily: 'Poppins, sans-serif' }}>
              Our Services
            </a>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="section intro">
        <div className="container text-center">
          <h2 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '700' }}>Evidence in Action</h2>
          <p className="lead" style={{ color: '#374151', fontFamily: 'Poppins, sans-serif' }}>
            Our projects embody our theory of change: Locally owned, inclusively executed initiatives that strengthen systems and drive sustainable outcomes.
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section id="projects" className="section case-studies-grid">
        <div className="container">
          <div className="cases-grid-wrapper" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
            {projects.map((project, idx) => (
              <div key={idx} className="case-card" style={{ border: '1px solid #E5E7EB', borderRadius: '12px', padding: '20px', background: '#fff', transition: 'transform 0.3s' }}>
                <div className="case-icon" style={{ marginBottom: '15px' }}>
                  {project.icon}
                </div>
                <h3 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '600', marginBottom: '8px' }}>{project.title}</h3>
                <div className="case-meta" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6B7280', marginBottom: '12px' }}>
                  <span className="client">{project.client}</span>
                  <span className="date"><Calendar size={16} /> {project.date}</span>
                </div>
                <p className="case-description" style={{ color: '#374151', fontFamily: 'Poppins, sans-serif', minHeight: '70px' }}>{project.description}</p>
                <div className="case-results" style={{ marginTop: '12px' }}>
                  <h4 style={{ color: '#F7941D', fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>Key Outcomes</h4>
                  <p style={{ color: '#374151', fontFamily: 'Poppins, sans-serif' }}>{project.results}</p>
                </div>
                <button
                  onClick={() => setActiveProject(project)}
                  className="case-link"
                  style={{
                    marginTop: '15px',
                    background: '#BA477C',
                    color: '#fff',
                    borderRadius: '8px',
                    padding: '10px 15px',
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily: 'Poppins, sans-serif'
                  }}
                >
                  View Details <ArrowRight size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal for Project Details */}
      {activeProject && (
        <div className="modal-overlay" onClick={() => setActiveProject(null)} style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 50
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            background: '#fff', padding: '30px', borderRadius: '12px', maxWidth: '700px', width: '90%', maxHeight: '90%', overflowY: 'auto'
          }}>
            <h2 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '700' }}>{activeProject.title}</h2>
            <p style={{ fontFamily: 'Poppins, sans-serif', color: '#374151', marginBottom: '15px' }}><strong>Client:</strong> {activeProject.client}</p>
            <p style={{ fontFamily: 'Poppins, sans-serif', color: '#374151', marginBottom: '15px' }}><strong>Date:</strong> {activeProject.date}</p>
            <p style={{ fontFamily: 'Poppins, sans-serif', color: '#374151', marginBottom: '15px' }}><strong>Description:</strong> {activeProject.description}</p>
            <p style={{ fontFamily: 'Poppins, sans-serif', color: '#374151', marginBottom: '15px' }}><strong>Key Outcomes:</strong> {activeProject.results}</p>
            <button
              onClick={() => setActiveProject(null)}
              style={{ marginTop: '20px', background: '#F7941D', color: '#fff', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontFamily: 'Poppins, sans-serif' }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* CTA */}
      <section className="final-cta text-center" style={{ background: '#F7941D', color: '#fff', padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '700' }}>
            Ready to Launch Your Impact Project?<br />Partner with DevLearn for Evidence-Led Success.
          </h2>
          <a href="/contact" className="btn btn-primary" style={{ background: '#BA477C', color: '#fff', marginTop: '20px', fontFamily: 'Poppins, sans-serif', padding: '12px 25px', borderRadius: '8px' }}>
            Start Collaboration <ArrowRight size={20} />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" style={{ background: '#111827', color: '#fff', padding: '50px 20px' }}>
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
          <div>
            <div className="footer-logo" style={{ color: '#F7941D', fontFamily: 'Poppins, sans-serif', fontWeight: '700', marginBottom: '10px' }}>DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>
          <div>
            <h4 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>Services</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="/services" style={{ color: '#FBB040', textDecoration: 'none' }}>Applied Research</a></li>
              <li><a href="/services" style={{ color: '#FBB040', textDecoration: 'none' }}>MERL Frameworks</a></li>
              <li><a href="/services" style={{ color: '#FBB040', textDecoration: 'none' }}>Capacity Building</a></li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>Thematic Areas</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="/sectors" style={{ color: '#FBB040', textDecoration: 'none' }}>Education & Health</a></li>
              <li><a href="/sectors" style={{ color: '#FBB040', textDecoration: 'none' }}>Governance & Climate</a></li>
              <li><a href="/sectors" style={{ color: '#FBB040', textDecoration: 'none' }}>Economic Inclusion</a></li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="/about" style={{ color: '#FBB040', textDecoration: 'none' }}>About</a></li>
              <li><a href="/team" style={{ color: '#FBB040', textDecoration: 'none' }}>Team</a></li>
              <li><a href="/case-studies" style={{ color: '#FBB040', textDecoration: 'none' }}>Projects</a></li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: '#BA477C', fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>Connect</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li><a href="https://www.linkedin.com/company/devlearn-impact-research/" style={{ color: '#FBB040', textDecoration: 'none' }}>LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/" style={{ color: '#FBB040', textDecoration: 'none' }}>Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright" style={{ color: '#9CA3AF', marginTop: '30px', fontFamily: 'Poppins, sans-serif', fontSize: '14px' }}>
          © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>
    </>
  );
};

export default CaseStudies;


// // pages/CaseStudies/CaseStudies.jsx - Projects page adapted for DevLearn (from PDF page 14 + inferred examples)
// import { ArrowRight, FileText, Calendar, TrendingUp, Award, Shield } from 'lucide-react';
// import '../../index.css'; // Shared global styles with palette
// import './CaseStudies.css'; // Page-specific styles

// const CaseStudies = () => {
//   const projects = [
//     {
//       title: 'Development of Comprehensive Safeguarding, Safety, and Well-Being Database',
//       client: 'Restless Development Zambia',
//       date: 'October - December 2025',
//       description: 'Conducting regional needs assessment, designing a multilingual safeguarding and well-being database, creating youth-friendly training materials on safeguarding, digital safety, and mental health, and facilitating validation and capacity-building sessions with youth CSOs.',
//       results: 'Ongoing: Building inclusive tools to protect and empower Zambian youth; expected reach: 500+ CSOs; integrates MERL for real-time monitoring.',
//       icon: <Shield size={56} />
//     },
//     {
//       title: 'Health Systems Evaluation for HIV/AIDS Interventions',
//       client: 'CIDRZ & NFNC Partnership',
//       date: '2024',
//       description: 'Mixed-methods impact evaluation of RMNCAH and HIV/AIDS programs, using STATA and NVivo for data analysis and stakeholder engagement.',
//       results: 'Improved program efficacy by 25%; informed policy for 10,000+ beneficiaries; led to scaled clinical trials.',
//       icon: <TrendingUp size={56} />
//     },
//     {
//       title: 'Governance and Anti-Corruption Policy Analysis',
//       client: 'UNECA & Oxfam Zambia',
//       date: '2023',
//       description: 'Political economy analysis and citizen surveys to evaluate transparency measures, with econometric modeling for policy recommendations.',
//       results: 'Influenced legislative reforms; 15% increase in public trust metrics; supported multi-stakeholder advocacy.',
//       icon: <FileText size={56} />
//     },
//     {
//       title: 'Youth Skills and Entrepreneurship Training Framework',
//       client: 'ChildFund Zambia',
//       date: '2024',
//       description: 'Designed digital skills curriculum and employability assessments for underserved youth, incorporating participatory M&E with KoboToolbox.',
//       results: 'Trained 2,000+ youth; 30% employability boost; adopted as national model for future-of-work programs.',
//       icon: <Award size={56} />
//     },
//     {
//       title: 'Climate Resilience and Green Livelihoods Assessment',
//       client: 'Prospero & Local CSOs',
//       date: '2025 (Ongoing)',
//       description: 'Community-led evaluation of adaptation practices using satellite data and mixed-methods, focusing on environmental justice in rural Zambia.',
//       results: 'Enhanced yields for 1,500 farmers; reduced emissions by 20%; guided donor funding for sustainability.',
//       icon: <TrendingUp size={56} />
//     }
//   ];

//   return (
//     <>
//       {/* Hero */}
//       <section className="hero" style={{ background: 'linear-gradient(180deg, #F0F9FF 0%, #ffffff 100%)' }}>
//         <div className="container">
//           <h1 style={{ color: '#1E3A8A' }}>Our Projects</h1>
//           <p>
//             Real-world applications of our MERL expertise. From youth safeguarding to governance reforms, explore how DevLearn delivers measurable, evidence-led impact in Zambia and across Africa.
//           </p>
//           <div className="hero-buttons">
//             <a href="#projects" className="btn btn-primary">
//               Explore Projects <ArrowRight />
//             </a>
//             <a href="/services" className="btn btn-secondary">
//               Our Services
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Introduction */}
//       <section className="section intro">
//         <div className="container">
//           <div className="text-center">
//             <h2 style={{ color: '#1E3A8A' }}>Evidence in Action</h2>
//             <p className="lead">
//               Our projects embody our theory of change: Locally owned, inclusively executed initiatives that strengthen systems and drive sustainable outcomes.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Projects Grid */}
//       <section id="projects" className="section case-studies-grid">
//         <div className="container">
//           <div className="cases-grid-wrapper">
//             {projects.map((project, index) => (
//               <div key={index} className="case-card">
//                 <div className="case-icon">
//                   {project.icon}
//                 </div>
//                 <div className="case-header">
//                   <h3 style={{ color: '#1E3A8A' }}>{project.title}</h3>
//                   <div className="case-meta">
//                     <span className="client">{project.client}</span>
//                     <span className="date"><Calendar size={16} /> {project.date}</span>
//                   </div>
//                 </div>
//                 <p className="case-description">{project.description}</p>
//                 <div className="case-results">
//                   <h4 style={{ color: '#0D9488' }}>Key Outcomes</h4>
//                   <p>{project.results}</p>
//                 </div>
//                 <a href="#" className="case-link">Read Full Report <ArrowRight size={20} /></a>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="final-cta text-center" style={{ background: '#1E3A8A', color: '#fff' }}>
//         <div className="container">
//           <h2>
//             Ready to Launch Your Impact Project?<br />Partner with DevLearn for Evidence-Led Success.
//           </h2>
//           <a href="/contact" className="btn btn-primary" style={{ background: '#fff', color: '#1E3A8A' }}>
//             Start Collaboration <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Reused with DevLearn details */}
//       <footer className="footer" style={{ background: '#111827' }}>
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo" style={{ color: '#0D9488' }}>DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright" style={{ color: '#9CA3AF' }}>
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default CaseStudies;


// // pages/CaseStudies/CaseStudies.jsx - Case Studies (Projects) page
// import { ArrowRight, FileText, Calendar, TrendingUp, Award } from 'lucide-react';
// import '../../index.css'; // Shared global styles
// import './CaseStudies.css'; // Page-specific styles

// const CaseStudies = () => {
//   const caseStudies = [
//     {
//       title: 'Evaluating Education Tech in Rural Kenya',
//       sector: 'Education',
//       date: '2024',
//       description: 'Assessed the impact of digital learning tools on student outcomes in underserved regions, using mixed-methods RCT.',
//       results: 'Improved literacy by 28% for 5,000+ students; informed national policy rollout.',
//       icon: <FileText size={56} />
//     },
//     {
//       title: 'Health Intervention Impact in Southeast Asia',
//       sector: 'Public Health',
//       date: '2023',
//       description: 'Conducted a multi-country evaluation of vaccination campaigns, analyzing coverage and efficacy via longitudinal data.',
//       results: 'Reached 1M+ beneficiaries; reduced disease incidence by 42%; scaled to regional programs.',
//       icon: <TrendingUp size={56} />
//     },
//     {
//       title: 'Financial Inclusion Strategy for African SMEs',
//       sector: 'Finance & Development',
//       date: '2024',
//       description: 'Designed and tested microfinance models for small businesses, incorporating qualitative stakeholder insights.',
//       results: 'Boosted access for 10,000+ enterprises; 35% increase in revenue; adopted by 3 banks.',
//       icon: <Award size={56} />
//     },
//     {
//       title: 'Sustainable Agriculture in Latin America',
//       sector: 'Agriculture & Environment',
//       date: '2022',
//       description: 'Measured climate-resilient farming practices through field trials and satellite data integration.',
//       results: 'Enhanced yields by 25% for 2,000 farmers; reduced emissions by 18%; guided donor funding.',
//       icon: <TrendingUp size={56} />
//     },
//     {
//       title: 'Governance Reform in Eastern Europe',
//       sector: 'Public Policy & Governance',
//       date: '2025',
//       description: 'Analyzed anti-corruption measures with citizen surveys and econometric modeling.',
//       results: 'Influenced legislative changes; 15% rise in public trust; ongoing advisory role.',
//       icon: <FileText size={56} />
//     }
//   ];

//   return (
//     <>
//       {/* Hero */}
//       <section className="hero">
//         <div className="container">
//           <h1>Case Studies</h1>
//           <p>
//             Real-world examples of our research in action. From policy-shaping evaluations to innovative
//             strategies, see how we've delivered measurable impact across sectors and continents.
//           </p>
//           <div className="hero-buttons">
//             <a href="#projects" className="btn btn-primary">
//               Explore Projects <ArrowRight />
//             </a>
//             <a href="/services" className="btn btn-secondary">
//               Our Services
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Introduction */}
//       <section className="section intro">
//         <div className="container">
//           <div className="text-center">
//             <h2>Proven Impact</h2>
//             <p className="lead">
//               Each project showcases our commitment to rigorous methodology and actionable outcomes.
//               Browse our portfolio to discover how we can support your goals.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Case Studies Grid */}
//       <section id="projects" className="section case-studies-grid">
//         <div className="container">
//           <div className="cases-grid-wrapper">
//             {caseStudies.map((study, index) => (
//               <div key={index} className="case-card">
//                 <div className="case-icon">
//                   {study.icon}
//                 </div>
//                 <div className="case-header">
//                   <h3>{study.title}</h3>
//                   <div className="case-meta">
//                     <span className="sector">{study.sector}</span>
//                     <span className="date"><Calendar size={16} /> {study.date}</span>
//                   </div>
//                 </div>
//                 <p className="case-description">{study.description}</p>
//                 <div className="case-results">
//                   <h4>Key Outcomes</h4>
//                   <p>{study.results}</p>
//                 </div>
//                 <a href="#" className="case-link">Read Full Study <ArrowRight size={20} /></a>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="final-cta text-center bg-light">
//         <div className="container">
//           <h2>
//             Inspired by our work? Bring your project to life with InSight.
//           </h2>
//           <a href="/contact" className="btn btn-primary">
//             Start Your Project <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Reused for consistency */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">InSight Research</div>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Market Research</a></li>
//               <li><a href="/services">Impact Evaluation</a></li>
//               <li><a href="/services">Data Analytics</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Sectors</h4>
//             <ul>
//               <li><a href="/sectors">Education</a></li>
//               <li><a href="/sectors">Public Health</a></li>
//               <li><a href="/sectors">Finance & Development</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="#">Reports</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Contact</h4>
//             <ul>
//               <li><a href="/contact">hello@insightresearch.com</a></li>
//               <li><a href="/contact">Locations</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 InSight Research. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default CaseStudies;